import React from 'react';
import { FlowsQuestion } from '../../../../types/FlowsTypes';
import useFlowInputComponent from '../../../../hooks/useFlowsInputComponent';
import { SmtFile } from '../../../../../../../types/Form';
import LinkInput from '@flows/src/components/input/company-scan-inputs/link/LinkInput';

interface Props {
  question: FlowsQuestion;
  isEditable?: boolean;
}

const LinkInputComponent: React.FC<React.PropsWithChildren<Props>> = ({
  question,
  isEditable,
}) => {
  const {
    field: { value, onBlur },
    error,
  } = useFlowInputComponent({ question, defaultValue: null });

  const uploadedFile = value as SmtFile | undefined | null;

  const handleOnChange = (file: SmtFile | null) => {
    onBlur({
      name: question.id,
      value: file,
    });
  };

  return (
    <LinkInput
      value={uploadedFile}
      onChange={handleOnChange}
      supportedLinkFormats={
        question.rules.options?.supported_mime_types ||
        question.rules.supported_mime_types
      }
      error={error}
      isDisabled={question.rules.is_disabled}
      withLink
      isEditable={isEditable}
    />
  );
};

export default LinkInputComponent;
